
import { useRef } from 'react'
import { CalendarIcon } from './icon'
import ReactDatePicker from 'react-datepicker'
import styles from './customeDatePicker.styles.module.scss'
import { ICustomeDatePicker } from './type'
import { OverlayTrigger } from 'react-bootstrap'

const CustomDatePicker = (props: ICustomeDatePicker) => {
    const { onChange, label, isRequired, className, minDate, maxDate,
        dateFormat, showTimeSelect, placeholder, includeTimes, timeIntervals, selected,
        labelSvgIcon: LabelSvgIcon, renderTooltip, popperPlacement, ...other } = props
    const calendarRef = useRef() as React.RefObject<ReactDatePicker>;
    return (
        <div className={`${styles.datePickerWrap}`}>
            <div className={styles.lableWithIcon}>
                <label className="form-label">
                    {label}
                    {isRequired && <span className={styles.requiredSing}>*</span>}
                </label>
                {LabelSvgIcon && renderTooltip ?
                    <OverlayTrigger
                        placement="bottom"
                        overlay={renderTooltip}
                    >
                        <LabelSvgIcon className={`${styles.labelSvgIcon}`} />
                    </OverlayTrigger>
                    :
                    LabelSvgIcon && <LabelSvgIcon className={`${styles.labelSvgIcon}`} />
                }
            </div>
            <div className={`${styles.datePickerWithIcon} `}>
                <ReactDatePicker
                    selected={selected}
                    onChange={onChange}
                    className={`${styles.datePicker} form-control ${className}`}
                    dateFormat={dateFormat ? dateFormat : "dd-MM-yyyy"}
                    ref={calendarRef}
                    placeholderText={placeholder || "DD-MM-YYYY"}
                    minDate={minDate}
                    maxDate={maxDate}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    showTimeSelect={showTimeSelect}
                    timeIntervals={timeIntervals}
                    includeTimes={includeTimes}
                    popperPlacement={popperPlacement || "bottom"}
                    {...other}
                />
                <div className={styles.dateIcon}>
                    <CalendarIcon onClick={() => {
                        calendarRef.current?.setOpen(true)
                    }
                    } />
                </div>
            </div>
        </div >
    )
}

export default CustomDatePicker